import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./SendReceiptContent.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import Spin from "components/Spin/Spin";
import RadioInput from "components/Input/RadioInput/RadioInput";

const PAGE_LOCALE_KEY = "page.transactions.sharedComponents.sendReceipt.";

const SendReceiptContent = ({ isOffline, isLoading, handleInput, data }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        {isOffline &&
          <RadioInput
            id="offline-transactions-send-email-receipt-radio-group"
            label={t(PAGE_LOCALE_KEY + "dialog.receiptOption.title")}
            value={data.receiptType}
            onChange={(e) => {
              handleInput(e.target.value, "receiptType");
            }}
            options={[
              {
                label: t(PAGE_LOCALE_KEY + "dialog.receiptOption.customer"),
                value: "CUSTOMER",
              },
              {
                label: t(PAGE_LOCALE_KEY + "dialog.receiptOption.merchant"),
                value: "MERCHANT",
              },
            ]}
            mandatory
          />}
        <OutlinedText
          label={t(PAGE_LOCALE_KEY + (data.receiptType === "MERCHANT" ? "dialog.content.1.merchant" : "dialog.content.1"))}
          noErrorMessage
          defaultValue={data.email ? data.email : ""}
          onchangeFn={(e) => textInputOnchange(e, "email")}
          onfocusFn={() => textInputOnFocus("email")}
          onblurFn={() => textInputOnBlur("email")}
          sxParams={{ textFocus: focus.email }}
          mandatory={!isOffline || (isOffline && data.receiptType === "CUSTOMER")}
        />
      </div>
      {isLoading && (
        <div className={s.spinContainer}>
          <Spin type={"search"} />
        </div>
      )}
    </div>
  );
};

export default SendReceiptContent;
